import 'regenerator-runtime/runtime';
import {
  call, put, fork, takeEvery,
} from 'redux-saga/effects';
import { parseError } from 'logic/helpers';
import api from 'api';
import * as actionCreators from './actionCreators';
import * as actions from './actions';

function* fetchBookingsListRequest(req) {
  try {
    const nextPageUrl = req.payload.nextPage;

    const { results, nextPage } = nextPageUrl ?
      (yield call(api.fetchNextPage.bind(null, nextPageUrl))) :
      (yield call(api.fetchBookingsList.bind(null, req.payload)));

    yield put(actionCreators.fetchBookingsListSuccess({ list: results, nextPage }));
  } catch (e) {
    yield put(actionCreators.fetchBookingsListFailure(parseError(e)));
  }
}

export default [
  fork(takeEvery, actions.FETCH_BOOKINGS_LIST_REQUEST, fetchBookingsListRequest),
];
